import last from 'lodash/last';
import { useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router';

import { BrandContext, TEMPO } from 'context/BrandContext';
import { FAMILY_MENU_PATH } from 'helpers/routes';
import useBrand from 'hooks/useBrand';
import { FAMILY } from 'lib/constants';

const Logo = () => {
  const location = useLocation();
  const { brand } = useContext(BrandContext);
  const isTempo = useBrand(TEMPO);
  const [logo, setLogo] = useState(null);

  const mealPlanSlug = last(location.pathname.split('/'));
  const linkPath = mealPlanSlug === FAMILY ? FAMILY_MENU_PATH : '/';

  useEffect(() => {
    if (!brand) return;
    const image = require(`images/logo/${brand}.svg`);
    setLogo(image);
  }, [brand]);

  const logoDimensions = {
    width: isTempo ? '94' : '31',
    height: isTempo ? '32' : '32',
  };

  return (
    <a href={linkPath}>
      <img
        src={logo}
        width={logoDimensions.width}
        height={logoDimensions.height}
        alt={`${brand} logo`}
      />
      <span className="sr-only">Go to home page</span>
    </a>
  );
};

export default Logo;
